import { fetchMFAPreference } from 'aws-amplify/auth'
import { createApiClient } from 'src/lib/api-client'
import useSWR, { SWRConfiguration } from 'swr'

import { Account } from '../../types'
import { accountCacheKey } from '../cacheKey'
import { parseAccountResponse } from '../parser'

export const getAccount = async () => {
  try {
    const res = await createApiClient({
      path: '/accounts/user',
      httpMethod: 'get',
    }).request()

    if (res.result === 'error') {
      throw new Error()
    }
    const mfaEnabled =
      res.data.login_method === 'Password'
        ? ((await fetchMFAPreference()).enabled?.includes('TOTP') ?? false)
        : false
    return parseAccountResponse(res.data, mfaEnabled)
  } catch (_) {
    throw new Error('user is not authenticated')
  }
}

export const useAccount = (
  args?: { shouldCancel?: boolean } & SWRConfiguration<Account, Error>,
) => {
  const { shouldCancel, ...options } = args ?? {}
  return useSWR<Account, Error>(
    shouldCancel ? null : accountCacheKey.getAccount,
    () => getAccount(),
    options,
  )
}
